import gsap, { Power1, Power2 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from "../_app/cuchillo/core/Basics";
import LogoAnim from '../components/LogoAnim';

export default class Preloader {
    _container;
    _progress;
    _callbackHide;
    _isReady = false;
    _isShowEnd = false;

    static init () {
        this._container = GetBy.id('Preloader');
         if(isDebug) this._container.style.display = "none";

        this._depo = new LogoAnim(GetBy.class('__logo', this._container)[0]);
        this._luxe = new LogoAnim(GetBy.class('__logo', this._container)[1]);
        this._depo.showhide();

        setTimeout(()=> {
            this._luxe.show(()=> {
                setTimeout(()=> {
                this._isShowEnd = true;
                if(this._isReady) this.hide(this._callbackHide);
                },400);
            });
        }, 1400);
    }

    static update (__progress) {
        gsap.killTweensOf(this._progress);
        gsap.to(this._progress, {
            scaleX: __progress,
            ease: Power1.easeOut,
            duration: .1
        });
    }

    static hide (__call) {
        if(isDebug)  {
            __call();
            return;
        }

        this._callbackHide = __call;
        this._isReady = true;

        if(!this._isShowEnd) return;

        this._luxe.hide(()=> {
            gsap.to(this._container, {
            alpha: 0,
            duration: .2,
            opacity: 0,
            delay: 0,
            ease: Power2.easeIn,
            onComplete: () => {
                this._container.style.display = "none";
                __call();
            }
        });
        });
        
    }
}
